import type { ParsedUrlQuery } from "querystring";

export const CAMPAIGN_QUERY_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
] as const;

export type CampaignQueryKey = (typeof CAMPAIGN_QUERY_KEYS)[number];

export function campaignParamsFromQuery(query: ParsedUrlQuery): URLSearchParams {
  const params = new URLSearchParams();

  for (const key of CAMPAIGN_QUERY_KEYS) {
    const raw = query[key];
    const value = Array.isArray(raw) ? raw[0] : raw;
    if (typeof value === "string" && value.trim()) {
      params.set(key, value.trim().slice(0, 160));
    }
  }

  return params;
}

export function withCampaignParams(
  href: string,
  campaignParams: URLSearchParams,
): string {
  if ([...campaignParams.keys()].length === 0) return href;

  const [pathAndQuery = href, hash] = href.split("#", 2);
  const [path = href, existingQuery] = pathAndQuery.split("?", 2);
  const merged = new URLSearchParams(existingQuery || "");

  campaignParams.forEach((value, key) => merged.set(key, value));

  return `${path}?${merged.toString()}${hash ? `#${hash}` : ""}`;
}
